import type { PlatformOptions } from "../../shared/apollo/OneGraphApolloClientProvider";

declare global {
     
    var graphqlUrl: string | undefined;
    var graphqlIndeedApiKey: string | undefined;
     
}

/**
 * Resolution order for OneGraph URL and API key:
 *   1. `globalThis.graphqlUrl` / `globalThis.graphqlIndeedApiKey` — host-injected
 *      globals. Matches the convention used by `apps/profile` and `apps/onboarding`,
 *      and the JSF EJS injection added in JSF-628. Preferred for new integrations
 *      (homepage / SERP embed of RNVJ).
 *   2. `window._initialData.viewJobClientSideModel.oneGraphApi…` — when the page
 *      itself is a server-rendered ViewJob.
 *   3. `_rootProps.preloadedVJData.oneGraphApi…` — legacy embed via
 *      `mountViewJob({ preloadedVJData })` whose model carries the values.
 */
export function getPlatformOptions(): PlatformOptions {
    return {
        web: {
            graphqlUrl:
                globalThis.graphqlUrl ??
                window._initialData?.viewJobClientSideModel?.oneGraphApiUrl ??
                globalThis._rootProps?.preloadedVJData?.oneGraphApiUrl,
            graphqlApiKey:
                globalThis.graphqlIndeedApiKey ??
                window._initialData?.viewJobClientSideModel?.oneGraphApiKey ??
                globalThis._rootProps?.preloadedVJData?.oneGraphApiKey,
        },
    };
}
